// Shared Co-Pilot compliance disclaimer (CR-20260720-001, M8 / R8).
//
// The SECOND sanctioned shared Co-Pilot export, after expiration-dates.ts. Sanctioned by the owner
// 2026-07-20 ("r8 - make shared constant"), on the same test that file states: the isolated-sibling
// rule duplicates STYLE per folder, but a single correctness fact is safe - and better - shared.
//
// Why this one qualifies where Co-Pilot logic does not: duplicating LOGIC is a feature, because it
// lets each Co-Pilot evolve without dragging the others along. Duplicating a LEGAL CONSTANT has no
// such upside - the copies must stay identical forever, so every copy is pure drift risk. The
// family rule's logic inverts for this content, which is why it needed an explicit owner ruling
// rather than a judgement call taken in passing.
//
// Rendered by all five Co-Pilot result surfaces:
//   copilot-shared/     opg-trade-card, opg-trade-stack (the Preview-All bar)
//   adjustment-pricing-grid/copilot/  apg-copilot-snippet-card
//   hedging-grid/copilot/             hg-copilot-solution-card, hg-copilot-close-all-card
//
// Pure / Angular-free, matching expiration-dates.ts - no module dependency, trivially assertable.

export interface CopilotDisclaimer {
    // Rendered bold, in its own span, followed by a plain-weight colon.
    readonly label: string;
    // Rendered after "<label>: ".
    //
    // PLAIN TEXT, NOT MARKUP. It is interpolated with {{ }}, which escapes HTML, so it must contain
    // no tags and no entities: an "&mdash;" here would render as those eight literal characters.
    // That is why the dash below is a real em-dash character and not the entity the templates used
    // before this constant existed.
    readonly text: string;
}

// The literal em-dash is deliberate. The comparable hazard on this codebase (CR pkg-03) was a
// literal NON-BREAKING SPACE, which transport silently normalized to a regular space - invisible
// both in review and on screen, so it needed the entity form. An em-dash carries no such risk: it
// is visible, so any mangling shows up immediately in the rendered line and in smoke. Spelling it
// out keeps the legal string auditable as written, which matters more than ASCII purity for the one
// value in this file a compliance reviewer will actually read. It is the file's only non-ASCII byte.
//
// WORDING IS OWNER-SET (2026-07-20) AND SUPERSEDES the earlier "* - For informational ..." form
// still visible in the source screencast. Do not "restore" the asterisk from that recording.
// Any change to this string is a COMPLIANCE change: it must be re-approved, never refactored.
export const COPILOT_DISCLAIMER: CopilotDisclaimer = {
    label: 'Disclaimer',
    text: 'Results Are For Informational And Educational Purposes Only — ' +
        'Not Investment, Financial, or Legal Advice'
};
